import * as React from 'react';

/** @description Меняет значения стиля для курсора
 * @param on {boolean} триггер
 * @param ref {React.RefObject<HTMLDivElement>} ссылка на элемент
 * @return {void}
 */
export const toggleCursorStyles = (on: boolean, ref: React.RefObject<HTMLDivElement>) => {
  document.body.style.cursor = on ? 'grabbing' : '';

  /* istanbul ignore next */
  if (ref.current) {
    ref.current.style.cursor = on ? 'grabbing' : 'grab';
  }
};
